<!--
 * @Author: Gaho
 * @Date: 2024-02-26 13:46:41
 * @LastEditors: Gaho
 * @LastEditTime: 2025-02-10 17:04:08
 * @Description: 
-->
<template>
    <div class="card-bg">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            class="background-gradient"
            viewBox="0 0 161 159"
        >
            <rect width="161" height="159" fill="#5638B2" fill-opacity=".45" rx="14"></rect>
            <g><circle cx="50%" cy="50%" r="64" fill="currentColor" filter="url(#abc)"></circle></g>
            <defs>
                <filter
                    id="abc"
                    width="159.635"
                    height="158.222"
                    x=".6825"
                    y=".6825"
                    color-interpolation-filters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
                    <feGaussianBlur stdDeviation="17.6587"></feGaussianBlur>
                </filter>
            </defs>
        </svg>
        <img src="@/assets/imgs/casino/corgiwild/double-bar.webp" class="card-double-img" alt="" />
        <img src="@/assets/imgs/casino/corgiwild/double-bar.webp" class="card-double-img" alt="" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'corgiwild-card-double',
});
</script>
<style lang="scss" scoped>
.card-double-img {
    left: 50%;
    position: absolute;
    top: 40%;
    transform: translate(-45%, -45%) scale(1);
    z-index: 2;
    width: 100%;
    &:nth-child(2) {
        animation-delay: 0.3s !important;
        top: 68%;
        @media (max-width: 576px) {
            top: 70%;
        }
    }
}
</style>
